import { Icon } from '@chakra-ui/react';

export const NetchexPlus = (props) => (
  <Icon viewBox="0 0 12 13" boxSize="16px" color="icon.g1" {...props}>
    <path
      d="M12 6.5C12 6.875 11.6827 7.19231 11.3077 7.19231H6.69231V11.8077C6.69231 12.1827 6.375 12.5 6 12.5C5.625 12.5 5.30769 12.1827 5.30769 11.8077V7.19231H0.692308C0.317308 7.19231 0 6.875 0 6.5C0 6.125 0.317308 5.80769 0.692308 5.80769H5.30769V1.19231C5.30769 0.817308 5.625 0.5 6 0.5C6.375 0.5 6.69231 0.817308 6.69231 1.19231V5.80769H11.3077C11.6827 5.80769 12 6.125 12 6.5Z"
      fill="#757575"
    />
  </Icon>
);
